var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-contact-distributions" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "time-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon time-icon" },
                [_c("md-icon", [_vm._v("schedule")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.timeDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("time-section")
                  ? _c("ContactDistributionsByTime", {
                      attrs: {
                        title: _vm.$t("chart.timeDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byTime,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "channel-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon channel-icon" },
                [_c("md-icon", [_vm._v("device_hub")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.channelDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("channel-section")
                  ? _c("ContactDistributionsByChannel", {
                      attrs: {
                        title: _vm.$t("chart.channelDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byChannel,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "tag-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon tag-icon" },
                [_c("md-icon", [_vm._v("label")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.tagDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("tag-section")
                  ? _c("ContactDistributionsByTag", {
                      attrs: {
                        title: _vm.$t("chart.tagDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byTag,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "platform-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon platform-icon" },
                [_c("md-icon", [_vm._v("devices")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("chart.platformDistribution"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("platform-section")
                  ? _c("ContactDistributionsByPlatform", {
                      attrs: {
                        title: _vm.$t("chart.platformDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byPlatform,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "owner-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon owner-icon" },
                [_c("md-icon", [_vm._v("person")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.ownerDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("owner-section")
                  ? _c("ContactDistributionsByOwner", {
                      attrs: {
                        title: _vm.$t("chart.ownerDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byOwner,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "language-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon language-icon" },
                [_c("md-icon", [_vm._v("translate")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("chart.languageDistribution"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("language-section")
                  ? _c("ContactDistributionsByLanguage", {
                      attrs: {
                        title: _vm.$t("chart.languageDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byLanguage,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "ads-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon ads-icon" },
                [_c("md-icon", [_vm._v("campaign")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.adsDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("ads-section")
                  ? _c("ContactDistributionsByAd", {
                      attrs: {
                        title: _vm.$t("chart.adsDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byAd || [],
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "ad-name-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon adname-icon" },
                [_c("md-icon", [_vm._v("ads_click")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.adNameDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("ad-name-section")
                  ? _c("ContactDistributionsByAd", {
                      attrs: {
                        title: _vm.$t("chart.adNameDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byAdName || [],
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "adset-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon adset-icon" },
                [_c("md-icon", [_vm._v("view_carousel")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [_vm._v(_vm._s(_vm.$t("chart.adsetDistribution")))]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("adset-section")
                  ? _c("ContactDistributionsByAd", {
                      attrs: {
                        title: _vm.$t("chart.adsetDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byAdsetName || [],
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "campaign-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon campaign-icon" },
                [_c("md-icon", [_vm._v("flag")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("chart.campaignDistribution"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("campaign-section")
                  ? _c("ContactDistributionsByAd", {
                      attrs: {
                        title: _vm.$t("chart.campaignDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byCampaignName || [],
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "report-card", attrs: { id: "property-section" } },
          [
            _c("div", { staticClass: "report-card-header" }, [
              _c(
                "div",
                { staticClass: "report-card-icon property-icon" },
                [_c("md-icon", [_vm._v("tune")])],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "report-card-title" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("chart.contactPropertyDistribution"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "report-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chart.contactDistributionsSubtitle"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report-card-body" },
              [
                _vm.isVisible("property-section")
                  ? _c("ContactDistributionsByContactProperty", {
                      attrs: {
                        title: _vm.$t("chart.contactPropertyDistribution"),
                        filters: _vm.filters,
                        loading: _vm.loading,
                        data: _vm.data.byContactProperty,
                      },
                    })
                  : _c("div", { staticClass: "lazy-skeleton" }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section-navigator" },
      _vm._l(_vm.sections, function (section, index) {
        var _obj
        return _c(
          "div",
          {
            key: section.id,
            staticClass: "nav-item",
            class:
              ((_obj = {
                active: _vm.activeSection === section.id,
              }),
              (_obj["section-color-" + (index + 1)] = true),
              _obj),
            attrs: { title: section.title },
            on: {
              click: function ($event) {
                return _vm.scrollToSection(section.id)
              },
            },
          },
          [
            _c("div", { staticClass: "invisible-hover-area" }),
            _vm._v(" "),
            _c("div", { staticClass: "nav-line" }),
            _vm._v(" "),
            _c("div", { staticClass: "nav-overlay" }, [
              _c("span", { staticClass: "nav-text" }, [
                _vm._v(_vm._s(section.title)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }